<template>
    <div style="margin: 0 20px;">
		<div class="so">
			<el-input placeholder="输入商品名称搜索" v-model="search">
			  <el-button slot="append" icon="el-icon-search" @click="searchClick"></el-button>
			</el-input>
		</div>
		<div style="float: right;" @click="createdGoods">
			<el-button type="primary">新建商品</el-button>
		</div>
        <ex-table style="height: 78vh; margin-bottom: 10px;" height="760" :data="tableData" show-pagination :search-method="handleSearch" ref="table">
            <el-table-column prop="date" label="商品图片" width="180" align="center">
				<template slot-scope="scope">
					<el-image style ="width:100px; height: 100px" :src="scope.row.productPicture"
					:preview-src-list="[scope.row.productPicture]"></el-image>
			　　	</template>
			</el-table-column>
            <el-table-column prop="productName" label="商品名称" align="center"></el-table-column>
            <el-table-column prop="productNum" label="商品库存" width="180" align="center"></el-table-column>
			<el-table-column prop="productPrice" label="商品原价" width="180" align="center"></el-table-column>
			<el-table-column prop="productSellingPrice" label="实际价格" width="180" align="center"></el-table-column>
			<el-table-column prop="isSell" label="是否上架" align="center">
				<template slot-scope="scope">
					<el-switch
					  v-model="scope.row.isSell"
					  active-text="上架"
					  inactive-text="下架"
					  active-color="#13ce66"
					  inactive-color="#ff4949"
					  :active-value="0"
					  :inactive-value="1"
					  @change="switchChange($event, scope.row, scope.$index)">
					</el-switch>
			　　</template>
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<el-button size="mini" type="danger" @click="deleteGoods(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
        </ex-table>
		<el-button type="text" @click="$refs.table.setCurrentPage(1)"></el-button>
    </div>
</template>
<script>
import ExTable from "../components/table.js"
export default {
    components: { ExTable },
    data() {
        return {
			search:"",
            tableData: []
        }
    },
    methods: {
        handleSearch(pagination, { currentPage, pageSize }) {
            this.fetchRemoteData(currentPage, pageSize)
        },
        fetchRemoteData(currentPage, pageSize) {
            //currentPage：当前页， pageSize: 每页最大条目数， 用于服务端分页
            //假设http请求数据，结果返回｛data_list: [...], total: ..｝
            //设置表格数据
            // this.data = request.data_list;
			
			this.$axios.post("/api/product/backend/getBusinessesProducts", {
			    page:currentPage,
				size:pageSize,
				productName:this.search
			}).then(res => {
			    if (res.data.code === "200" || res.data.code === 200) {
					this.tableData = res.data.data.productList
					//设置分页总数
					const pagination = this.$refs.table.pagination;
					pagination.total = res.data.data.totalCount;
			    } else {
					// 提示失败信息
					this.notifyError(res.data.msg);
			    }
			}).catch(err => {
			    return Promise.reject(err);
			});
        },
		//搜索
		searchClick(){
			this.fetchRemoteData(1, 10)
		},
		//新建商品
		createdGoods(){
			this.$router.push({ path: "/admin/goods/created" });
		},
		//商品上下架
		switchChange(e,row,index){
			this.$axios.post("/api/product/backend/upperOrlowerShelves", {
			    productId:row.productId,
				isSell:e
			}).then(res => {
			    if (res.data.code === "200" || res.data.code === 200) {
					row.isSell = e
			    } else {
					// 提示失败信息
					this.notifyError(res.data.msg);
			    }
			}).catch(err => {
			    return Promise.reject(err);
			});
		},
		//删除商品
		deleteGoods(index,row){
			let _this = this
			this.$confirm('删除后不可恢复, 是否继续?', '确定要删除此商品吗？', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				_this.$axios.post("/api/product/backend/deleteProduct", {
				    productId:row.productId,
				}).then(res => {
				    if (res.data.code === "200" || res.data.code === 200) {
						// 提示成功信息
						_this.notifySucceed("删除成功");
						_this.fetchRemoteData(1, 10)
				    } else {
						// 提示失败信息
						_this.notifyError(res.data.msg);
				    }
				}).catch(err => {
				    return Promise.reject(err);
				});
			}).catch(() => {
				          
			});
		},
    },
    mounted() {
        this.$refs.table.fetchData();
    }
}
</script>

<style>
	.so {
	  margin-bottom: 10px;
	  width: 300px;
	  float: left;
	}
</style>